<template>
  <div class="text-center p-3">
    <div :class="[displayInline ? 'mr-2' : 'd-block mb-3']">
      <b-spinner label="Loading..." variant="secondary" :class="[small ? 'small' : 'spinner-large']"></b-spinner>
    </div>
    <span class="text-secondary" :class="small ? '' : 'spinner-message'">{{ message }}</span>
  </div>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    displayInline: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.spinner-large {
  width: 3rem;
  height: 3rem;
}

.spinner-message {
  font-size: 1.2rem;
}
</style>
